import { MultiService } from 'modules/api/MultiService';
import { RequestType, web3Api } from 'store/queries';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchIsAccountCreationAllowed },
  useFetchIsAccountCreationAllowedQuery,
  useLazyFetchIsAccountCreationAllowedQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchIsAccountCreationAllowed: build.query<boolean, void>({
      providesTags: [RequestType.TeamCreationPermission],
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async () => {
          const api = MultiService.getService().getAccountingGateway();

          const {
            result: { groupCreationAvailable },
          } = await api.getIsGroupCreationAvailable();

          return { data: groupCreationAvailable };
        },
      }),
    }),
  }),
  overrideExisting: true,
});

const fetchIsAccountCreationAllowedFallback = false;

export const {
  selectDataCachedByParams: selectIsAccountCreationAllowed,
  selectLoadingCachedByParams: selectIsAccountCreationAllowedLoading,
} = createQuerySelectors({
  endpoint: fetchIsAccountCreationAllowed,
  fallback: fetchIsAccountCreationAllowedFallback,
});
